export default function GaugeMeter({ score, label, size = 100, invert = false }) {
  const displayScore = invert ? 100 - score : score;
  const normalizedScore = Math.max(0, Math.min(100, displayScore));
  const radius = (size - 12) / 2;
  const circumference = Math.PI * radius;
  const offset = circumference - (normalizedScore / 100) * circumference;

  const getColor = (s) => {
    if (s >= 70) return "#10B981";
    if (s >= 40) return "#F59E0B";
    return "#EF4444";
  };
  const color = getColor(normalizedScore);

  return (
    <div className="flex flex-col items-center gap-1" data-testid={`gauge-${label?.toLowerCase().replace(/\s/g, '-')}`}>
      <svg width={size} height={size / 2 + 8} viewBox={`0 0 ${size} ${size / 2 + 8}`}>
        {/* Background arc */}
        <path
          d={`M 6 ${size / 2} A ${radius} ${radius} 0 0 1 ${size - 6} ${size / 2}`}
          fill="none"
          stroke="#1E293B"
          strokeWidth="8"
          strokeLinecap="round"
        />
        {/* Progress arc */}
        <path
          d={`M 6 ${size / 2} A ${radius} ${radius} 0 0 1 ${size - 6} ${size / 2}`}
          fill="none"
          stroke={color}
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.34, 1.56, 0.64, 1), stroke 0.5s ease" }}
        />
        {/* Score text */}
        <text x={size / 2} y={size / 2 - 2} textAnchor="middle" className="font-mono" fill={color} fontSize="16" fontWeight="600">
          {score.toFixed(1)}
        </text>
      </svg>
      {label && (
        <span className="text-[10px] text-slate-500 font-manrope tracking-wide text-center leading-tight max-w-[80px]">
          {label}
        </span>
      )}
    </div>
  );
}
